var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCalendarToday = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.444 2c.615 0 1.112.47 1.112 1.053h2.222c1.226 0 2.222.943 2.222 2.105v14.737C22 21.057 21.004 22 19.778 22H4.222C2.996 22 2 21.057 2 19.895V5.158c0-1.162.996-2.105 2.222-2.105h2.222C6.444 2.47 6.941 2 7.556 2c.614 0 1.11.47 1.11 1.053h6.667c0-.582.497-1.053 1.111-1.053m3.334 8.421H4.222v9.474h15.556zm-10.5 2.105a.5.5 0 0 1 .5.5v2.158a.5.5 0 0 1-.5.5H6.944a.5.5 0 0 1-.5-.5v-2.158a.5.5 0 0 1 .5-.5zM6.444 5.158H4.222v3.158h15.556V5.158h-2.222c0 .582-.497 1.053-1.112 1.053-.614 0-1.11-.471-1.11-1.053H8.666c0 .582-.497 1.053-1.111 1.053-.615 0-1.112-.471-1.112-1.053"
})));
export default SvgGemCalendarToday;